import { TranscriptEditTrimControls } from "./TranscriptEditTrimControls";
import { isDeepgramAsrFallbackStatus } from "../leadAsrListeningUi";

export function LeadsModeTranscriptBlock(props: {
  transcript: string;
  isListening: boolean;
  isAsrReconnecting?: boolean;
  asrStatus?: string;
  showTranscriptDetails: boolean;
  setShowTranscriptDetails: (fn: (v: boolean) => boolean) => void;
  commitTranscriptToCurrentLead: (next: string) => void;
}) {
  const {
    transcript,
    isListening,
    isAsrReconnecting = false,
    asrStatus = "",
    showTranscriptDetails,
    setShowTranscriptDetails,
    commitTranscriptToCurrentLead,
  } = props;

  const showFallbackStatus = !isAsrReconnecting && !!asrStatus && isDeepgramAsrFallbackStatus(asrStatus);
  const subtitle = transcript
    ? "Full conversation text from this call."
    : isAsrReconnecting
      ? "Reconnecting to live transcription…"
      : showFallbackStatus
        ? asrStatus
        : isListening
          ? "Listening for audio…"
          : "No audio captured yet.";

  const statusPillClass = isAsrReconnecting
    ? "bg-amber-100 text-amber-800"
    : showFallbackStatus
      ? "bg-amber-100 text-amber-800"
      : isListening
        ? "bg-blue-100 text-blue-700"
        : "bg-gray-200 text-gray-700";

  const statusPillLabel = isAsrReconnecting
    ? "Reconnecting…"
    : showFallbackStatus
      ? asrStatus
      : isListening
        ? "Listening…"
        : "Idle";

  return (
    <div className="bg-gray-100 p-4 sm:p-6 rounded-2xl">
      <div className="flex items-center justify-between mb-2 gap-2">
        <div className="text-left">
          <h2 className="text-lg sm:text-2xl font-bold">Transcript</h2>
          <p className="text-[11px] sm:text-xs text-gray-600">{subtitle}</p>
        </div>

        <div className="flex flex-col items-end gap-1">
          <span className={"inline-block text-[10px] px-2 py-1 rounded-full " + statusPillClass}>
            {statusPillLabel}
          </span>

          {transcript && (
            <button
              type="button"
              onClick={() => setShowTranscriptDetails((prev) => !prev)}
              className="text-[11px] text-blue-600 underline"
            >
              {showTranscriptDetails ? "Hide full transcript" : "Show full transcript"}
            </button>
          )}
          <TranscriptEditTrimControls
            transcript={transcript}
            commitTranscript={commitTranscriptToCurrentLead}
          />
        </div>
      </div>

      <div className="mt-2 text-sm sm:text-base text-gray-800 text-left">
        {transcript ? (
          <>
            <span className="font-semibold">Preview:</span> {transcript.slice(0, 160)}
            {transcript.length > 160 ? "…" : ""}
          </>
        ) : (
          <span className="italic text-gray-500">No transcript captured yet.</span>
        )}
      </div>

      {showTranscriptDetails && transcript ? (
        <div className="mt-3 max-h-48 sm:max-h-64 overflow-y-auto bg-white rounded-xl p-3 text-xs sm:text-sm font-mono text-gray-800">
          {transcript}
        </div>
      ) : null}
    </div>
  );
}
